<template>
  <div class="wrapper" v-if="viewFlag">
    <div class="content">
      <sr-header/>
      <router-view/>
    </div>
    <sr-footer/>
  </div>
</template>

<script>
  import axios from 'axios'
  import SrHeader from '@/components/header'
  import SrFooter from '@/components/footer'
  export default {
    components: {
      SrHeader,
      SrFooter
    },
    data () {
      return {
        viewFlag: false
      }
    },
    methods: {
      getImgUrl () {
        axios.get('/api/product/findImgUrl').then(res => {
          if (res.data.code === 9999) {
            this.$store.state.imgUrl = res.data.data
            this.viewFlag = true
          }
        })
      }
    },
    created () {
      this.getImgUrl()
    }
  }
</script>

<style lang="less" scoped>
  .wrapper {
    width: 100%;
    min-width: 1280px;
    min-height: 100%;
    display: flex;
    flex-direction: column;
    .content{
      flex: 1;
    }
  }
</style>



// WEBPACK FOOTER //
// src/pages/main/index.vue